export default "__VITE_ASSET__7abca96d__"